import React from 'react'

export const delawareSetupVars = {
  siteId: 'delaware',
  pathPrefix: '/de',
  menuHeader: "Discover Delaware's Solution for:",
  appUrl: 'https://de.headed2.com',
  logoImg: '/images/assets/delaware/horizontal/dark.svg',
  headerTitle: `The Delaware CareerExplorer is a system designed for Delaware`
}
